import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../stores/Store';
import { isMobile } from 'is-mobile';
import './style.scss';
import { Button, View, TextInput, Footer } from '../../components';

const loginImage = 'https://wealthcdn.aions.co.za/landscapes/Gauteng.png';
const successMessage = 'We will notify you when new opportunities are available';

const NotifyWhenLive = observer(() => {
  const store = useStore();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    setFeedback('');
    if (!firstName || !lastName || !email) {
      setError('Please complete all fields.');
      return;
    }
    store.setLoading(true);
    const response = await store.addUserToNotifyList(email, firstName, lastName);
    store.setLoading(false);
    setFeedback(response);
  };

  const renderInputs = () => (
    <>
      <TextInput
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        placeholder="First Name"
      />
      <TextInput
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        placeholder="Last Name"
      />
      <TextInput
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        type="email"
      />
      {error && <p className="notifyMessage error">{error}</p>}
      {feedback && (
        <p
          className={`notifyMessage ${
            feedback === successMessage ? 'success' : 'error'
          }`}
        >
          {feedback}
        </p>
      )}
    </>
  );

  if (isMobile() || store.isScreenMobile()) {
    return (
      <View
        className="notifyWhenLivePage"
        style={{
          height: `${store.screenHeight - 50}px`,
          justifyContent: 'space-between',
        }}
      >
        <div className="notifyWhenLiveForm">
          <p className="notifyWhenLiveHeading">
            <span className="welcomeUnderline">Notify</span> Me when{' '}
            <span className="welcomeUnderline">Live</span>
          </p>
          {renderInputs()}
        </div>
        <div className="notifyWhenLiveActions">
          <Button
            onClick={handleSubmit}
            enabled={firstName !== '' && lastName !== '' && email !== ''}
          >
            Notify Me
          </Button>
        </div>
        <img
          className="notifyWhenLiveImage"
          src={loginImage}
          alt="Notify When Live"
        />
        <Footer />
      </View>
    );
  }

  return (
    <View
      className="desktopView notifyWhenLiveDesktop"
      style={{
        overflow: 'scroll',
        height: `${store.screenHeight - 75}px`,
        alignItems: 'center',
      }}
    >
      <p className="notifyWhenLiveHeadingDesktop">
        <span className="welcomeUnderlineDesktop">Notify</span> Me when{' '}
        <span className="welcomeUnderlineDesktop">Live</span>
      </p>
      <div className="notifyWhenLiveDesktopForm">{renderInputs()}</div>
      <Button
        onClick={handleSubmit}
        enabled={firstName !== '' && lastName !== '' && email !== ''}
        style={{ marginTop: '16px', height: '48px', width: '40%' }}
      >
        Notify Me
      </Button>
      <img
        className="notifyWhenLiveImage desktop"
        src={loginImage}
        alt="Notify When Live"
      />
      <Footer />
    </View>
  );
});

export default NotifyWhenLive;
